import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '@techspert-io/user-alerts';
import { catchError, Observable, throwError } from 'rxjs';
import {
  IOutreachEmail,
  IOutreachEmailRes,
} from '../models/outreach-email.models';

@Injectable({
  providedIn: 'root',
})
export class OutreachEmailService {
  private readonly baseUrl = '/outreach/expert';

  constructor(
    private http: HttpClient,
    private toastService: ToastService
  ) {}

  send(req: IOutreachEmail): Observable<IOutreachEmailRes> {
    return this.http
      .post<IOutreachEmailRes>(
        `${this.baseUrl}/${req.expertId}/send-single`,
        req.email
      )
      .pipe(catchError((err) => this.handleError(err, 'Send failed')));
  }

  private handleError(err: Error, message: string) {
    if (err instanceof HttpErrorResponse) {
      this.toastService.sendMessage(`${message} ${err.message}`, 'error');
    } else {
      this.toastService.sendMessage(`${message} Unknown Error`, 'error');
    }
    return throwError(() => err);
  }
}
